import React,{useState,useEffect} from 'react';
import './Home.css';
import { Toaster } from 'react-hot-toast';
import { ModalRecibos,ModalFilter } from '../../utils/modals';
import moment from "moment";
import "moment/locale/es";
import { Row,Col,Form, Button} from 'react-bootstrap';
import TablaRecibos from '../TablaRecibos/TablaRecibos';
import { useSelector,useDispatch,getState } from 'react-redux';
import { setInitData,setStateHome } from '../../reducers/appReducer';

moment.locale("mx");

export const Home = () => {

  const stateHome = useSelector( (state) => state.agents.home );
  const dispatch = useDispatch();
  const { 
    section, 
    arrPagados, 
    arrPorPagar, 
    arrVencidos, 
    arrRenovaciones,
    showModalRecibos,
    showModalFiltros,
    recibosSearch,
    customDate,
    fechaInicio,
    fechaFin,
  } = stateHome;

  const today = moment().add(-1, 'year').format('YYYY-MM-DD');
  const tomorrow = moment(today,'YYYY-MM-DD').add(1, 'year').format('YYYY-MM-DD');

  const [state,setState] = useState({ changeTab: false });

  const handleSetSection = (section) => dispatch( setStateHome( { section } ) )
  const handleClose = () => dispatch( setStateHome({ showModalFiltros: false }) );
  const handleShow = () => dispatch( setStateHome({ showModalFiltros: true }) );
  const handleCloseModalRecibo = () => dispatch( setStateHome({ showModalRecibos: false }) );
  const handleShowModalRecibo = (t,company) => {
    dispatch( setStateHome( { showModalRecibos : true, isLoadingViewContrato: true,} ) );
    getViewContrato(t);
  }

  const handleSubmitSearch = (e) => {
    e.preventDefault();
    if(section===1) porPagar(); 
    if(section===2) pagados();
    if(section===3) vencidos();
    if(section===4) renovaciones();
  }

  useEffect(() => {
    if(!customDate){
      dispatch( setStateHome( { fechaInicio: today, fechaFin: tomorrow } ) )
    }
    //Get init data
    const data = {
      opt:'init'
    }
    fetch('REST/controllers/mainController?opt=init',{
      method:'post',
      mode:'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      dispatch(setInitData(response))
      porPagar();
    })
  },[]);

  const getViewContrato = (dataRecibo) => {
    const formData = new FormData();
    formData.append('id_contrato',dataRecibo.id_contrato);
    formData.append('id_usuario',dataRecibo.id_usuario);
    fetch('REST/controllers/directoryController?opt=getViewContrato',{
      method:'post',
      mode: 'cors',
      body: formData
    })
    .then( response => response.json())
    .then( response => {
      dispatch( setStateHome( { arrContrato : response, isLoadingViewContrato: false} ) );
    });
  }

  const porPagar = () => {
    setState({ ...state,changeTab: false });
    dispatch( setStateHome( { isLoadPanel: true } ) )
    const data = {
      inicio: fechaInicio,
      fin: fechaFin,
      opt: 'main'
    }
    fetch('REST/controllers/mainController?opt=main',{
      method:'post',
      mode: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      dispatch( setStateHome( { arrPorPagar: response.pendientes, isLoadPanel : false } ) )
    });
  }

  const pagados = () => {
    setState({ ...state, changeTab: false });
    dispatch( setStateHome( { isLoadPanel: true } ) )
    const data = {
      inicio: fechaInicio,
      fin: fechaFin,
      opt: 'main',
      option: 1
    }
    fetch('REST/controllers/mainController?opt=mainOptions',{
      method:'post',
      mode: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      dispatch( setStateHome( { arrPagados : response, isLoadPanel: false } ) )
    });
  }

  const vencidos = () => {
    setState({ ...state, changeTab: false });
    dispatch( setStateHome( { isLoadPanel: true } ) )
    const data = {
      inicio: fechaInicio,
      fin: fechaFin,
      option: 0
    }
    fetch('REST/controllers/mainController?opt=mainOptions',{
      method:'post',
      mode: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      dispatch( setStateHome( { arrVencidos : response, isLoadPanel: false } ) )
    });
  }

  const renovaciones = () => {
    setState({ ...state, changeTab: false });
    dispatch( setStateHome( { isLoadPanel: true } ) )
    const data = {
      inicio: fechaInicio,
      fin: fechaFin,
      opt: 'main',
      option: 2
    }
    fetch('REST/controllers/mainController?opt=getRenovaciones',{
      method:'post',
      mode: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      dispatch( setStateHome( { arrRenovaciones : response,isLoadPanel:false } ) )
    });
  }

  const searchData = recibosSearch.toLowerCase();
  let filteredData = [];
  let dataArray;

  if(section === 1) dataArray = arrPorPagar;
  if(section === 2) dataArray = arrPagados;
  if(section === 3) dataArray = arrVencidos;
  if(section === 4) dataArray = arrRenovaciones;

  if (recibosSearch == "") {
    filteredData = dataArray;
  } else {
    filteredData = dataArray.filter((el) => {
      const { nombre_usuario, numero_poliza } = el;
      return (
        nombre_usuario.toLowerCase().includes(searchData) ||
        numero_poliza.toLowerCase().includes(searchData)
      );
    });
  }

  return (
    <div className="container-fluid">
      <div className="ws-main-container">
        {/* Filtros */}
        <div className="ws-tab-container pb-3">
          {/* Tab section */}
          <ul className="nav nav-pills">
            <li className="nav-item">
              <a className={`nav-link ${ (section === 1) && 'active' }`} aria-current="page" href="#" onClick={ () => handleSetSection(1) }>Por Pagar <span className="ws-tabs-notification">(0)</span></a>
            </li>
            <li className="nav-item">
              <a className={`nav-link ms-2 ${ (section === 2) && 'active' }`} href="#" onClick={ () => handleSetSection(2) }>Pagados <span className="ws-tabs-notification">({arrPagados.length})</span></a>
            </li>
            <li className="nav-item">
              <a className={`nav-link ms-2 ${ (section === 3) && 'active' }`} href="#" onClick={ () => handleSetSection(3) }>Vencimientos <span className="ws-tabs-notification">({arrVencidos.length})</span></a>
            </li>
            <li className="nav-item">
              <a className={`nav-link ms-2 ${ (section === 4) && 'active' }`} href="#" onClick={ () => handleSetSection(4) }>Renovaciones <span className="ws-tabs-notification">(0)</span></a>
            </li>
          </ul>
          {/* Formulario de búsqueda por rango de fecha */}
          <Form onSubmit={handleSubmitSearch} className="d-flex flex-column align-items-end flex-md-row mt-3 gap-2">
            <Form.Group className="mb-1">
              <Form.Label>Inicio</Form.Label>
              <Form.Control type="date" value={fechaInicio} 
              onChange={ (e) => {
                dispatch( setStateHome( { customDate: true, fechaInicio: e.target.value } ) )
              } } />
            </Form.Group>
            <Form.Group className="mb-1">
              <Form.Label>Fin</Form.Label>
              <Form.Control type="date" value={fechaFin} 
              onChange={ (e) => {
                dispatch( setStateHome( { customDate: true, fechaFin: e.target.value } ))
              } } />
            </Form.Group>
            <Form.Group className="mb-1">
              <Button type="submit" className="ws-btn-blue-2"><i className="bi bi-search pe-2"></i> Buscar</Button>
            </Form.Group>
          </Form>
          {/* Formulario de búsqueda por filtro ingresado */}
          <Row className="mt-3">
            <Col xs={11}> 
              <Form onSubmit={ (e) => e.preventDefault() }>
                <Form.Group className="group-search">
                  <i className="bi bi-search pe-2"></i>
                  <Form.Control 
                  type="search"
                  className="ws-input-search"
                  placeholder="Filtrar por nombre, número de póliza, etc."
                  value={recibosSearch}
                  onChange={ (e) => dispatch( setStateHome( { recibosSearch: e.target.value } ) ) }
                  />
                </Form.Group>
              </Form>
            </Col>
            <Col xs={1}>
              <div className="ws-group-icons-tools d-flex justify-content-center align-items-center">
                <i className="bi bi-filter ws-icon-options-tools" title="Filtrar por" onClick={handleShow}></i>
                <i className="bi bi-download ws-icon-options-tools" title="Descargar reporte"></i>
              </div>
            </Col>
          </Row>
        </div>
        {/* TABLA DE LOS RECIBOS */}
        <TablaRecibos 
        state={state} 
        setState={setState}
        filteredData={filteredData} 
        handleShowModalRecibo={handleShowModalRecibo} 
        />
        {/* Modals */}
        <ModalFilter show={showModalFiltros} handleClose={ handleClose } />  
        {/* MODAL RECIBOS */}
        <ModalRecibos
        show={showModalRecibos} 
        handleClose={ handleCloseModalRecibo }
        getViewContrato={getViewContrato}
        homeSection={section}
        />
        {/* TOAST NOTIFICATION */}
        <Toaster position='top-right' />
      </div>
    </div>
  )
}